import { render, staticRenderFns } from "./VendaAgora.vue?vue&type=template&id=24598d43&"
import script from "./VendaAgora.js?vue&type=script&lang=js&"
export * from "./VendaAgora.js?vue&type=script&lang=js&"
import style0 from "./VendaAgora.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QNoSsr from 'quasar/src/components/no-ssr/QNoSsr.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QNoSsr,QBtn});
